
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.586 11.714v5.047m3.871-5.047v5.047m3.978-5.047v5.047M3.679 6.646L7.72 1m5.517 0l4.042 5.646"}}),_c('rect',{attrs:{"x":".534","y":"6.752","width":"19.931","height":"2.781","rx":"1.39"}}),_c('path',{attrs:{"d":"M1.625 9.81l2.31 9.282h6.544m8.853-9.282l-2.31 9.282H10.48"}})])
          )
        }
      }
    